import { Type, Service } from '@angular/core';

@Service()
export class ComponentRegistry {
  private readonly map = new Map<string, Type<unknown>>();
  register(type: string, cmp: Type<unknown>) {
    this.map.set(type, cmp);
  }
  resolve(type: string) {
    return this.map.get(type);
  }
}
